(() => {
  const scope = document.getElementById('MainContent');
  if (!scope) return;

  const frames = '#tee-field--teeinblue-available-prod';
  const sizes = '.tee-option--size input[type="radio"]';
  let pending;

  const restoreSize = (selection) => {
    if (pending !== selection) return;

    // Teeinblue replaces the size radios for each frame's product base.
    const options = [...selection.form.querySelectorAll(sizes)]
      .filter((input) => input.id.startsWith(selection.prefix));

    if (!options.length) {
      if (performance.now() < selection.deadline) {
        requestAnimationFrame(() => restoreSize(selection));
      } else {
        pending = undefined;
      }
      return;
    }

    pending = undefined;
    const match = options.find((input) => input.value === selection.size && !input.disabled);
    if (match && !match.checked) match.labels[0]?.click();
  };

  const rememberSize = (event) => {
    const target = event.target;
    if (!event.isTrusted || !(target instanceof Element)) return;

    const input = target.closest('label')?.control || target;
    if (input.matches(sizes)) {
      pending = undefined;
      return;
    }
    if (!input.matches(`${frames} input[type="radio"]`) || input.disabled) return;

    // A label and its radio can both emit a click for the same interaction.
    if (pending?.frame === input.value || input.closest('.tee-radio.active')) return;

    const form = input.closest('#tee-artwork-form');
    const selected = form?.querySelector(`${sizes}:checked`);
    const campaign = selected?.id.match(/^size-(\d+)-\d+-/)?.[1];
    if (!campaign) return;

    const selection = {
      form,
      frame: input.value,
      prefix: `size-${campaign}-${input.value}-`,
      size: selected.value,
      deadline: performance.now() + 750,
    };
    pending = selection;
    requestAnimationFrame(() => restoreSize(selection));
  };

  scope.addEventListener('click', rememberSize, true);
  scope.addEventListener('change', rememberSize, true);
})();
